import {HoverCard, HoverCardTrigger, HoverCardContent} from "@/components/ui/hover-card.tsx";
import {Button} from "@/components/ui/button.tsx";
import {MouseEvent} from "react";


export default function PrintButton({children, onPrint}: { children: React.ReactNode, onPrint: (e: MouseEvent) => void }) {
    return <HoverCard>
        <HoverCardTrigger asChild>{children}</HoverCardTrigger>
        <HoverCardContent asChild>
            <Button onClick={onPrint} variant={"outline"}>
                Nyomdai verzió
            </Button>
        </HoverCardContent>
    </HoverCard>
}